//import 'ol/ol.css';
import * as toastr from "toastr";
import { Utilities, ModalAction } from '../Utility/Utilities';
import { Photos } from '../Photos/Photos';
import * as AuthModel from '../Models/AuthModel';
import * as events from '../Bus/Bus';
import { MapLayerGroupType, INewGeometryConfig } from '../Models/MapConfigModels';
import { CAMSMap } from '../../Extensions/CAMSOLExtensions';
import { Entity_RouteCondition, routeConditionCreateCallback } from './Entity_RouteCondition';
import { Entity_RouteContact } from './Entity_RouteContact';
import { Entity_RouteView } from './Entity_RouteView';
import { ICAMSKey, IAPIResult, FeatureType, IMapInteractionConfig, TextPack } from '../Models/UtilityModels';
import { OptionalTracingLayer } from '../Map/MainMap';
import GeometryType from 'ol/geom/GeometryType';
import { UserDefinedFields } from '../UserDefinedFields/UserDefinedFields';

// List of Jquery controls used in this class
enum jqc {
    placeholder_for_modals = '#placeholder-for-modals'
}

export class Routes {

    // ----------------------------------------------------------- //
    // GLOBAL VARS
    private initialised: boolean = false;
    private Entity_RouteContact = new Entity_RouteContact();
    private EntityRouteView: Entity_RouteView;
    private photos: Photos = new Photos();
    private routeCondition: Entity_RouteCondition = new Entity_RouteCondition();

    private eventNewMapGeometryCompleted;
    // ----------------------------------------------------------- //
    //Constructor
    public constructor(protected map: CAMSMap, protected authModel: AuthModel.IAuthModel) {
        this.initEvents();

        this.EntityRouteView = new Entity_RouteView(map, authModel);
    }

    private initEvents = (): void => {
        const self = this;
    }

    // ----------------------------------------------------------- //
    // PUBLIC Functions
    public openEditPanel = (data: ICAMSKey): void => {
        this.EntityRouteView.openEditPanel(data);
    }

    public openCreatePanel = (data: ICAMSKey): void => {
        const self = this;
        Utilities.BlockUI();
        $('#placeholder-for-modals').load(window.G_SITEFOLDERNAME +'/Route/RouteCreate', data, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();
            
            // Show the form
            Utilities.GetModal('#routeCreateModal', ModalAction.Create);

            // Get form validation
            Utilities.InitFormValidation($("#routeCreateModal"));

            //initialise photo uploader
            self.photos.setupUploader('#routeCreateModal');

            //preset length field from feature geom
            $('#Length').val(data.metadata.featureLength.toString());

            $('#routeCreateSubmitBtn').on('click', function (evt) {
                evt.preventDefault();
                submit(false);
            });

            $('#routeCreateSubmitAndEditBtn').on('click', function (evt) {
                evt.preventDefault();
                submit(true);
            });

            $('#routeCreateForm [name="RouteLinkNo"]').on('keyup', function (evt) {
                var routeCode = $('#routeCreateForm [name="RouteCode"]').val() as string;
                var t1 = routeCode.split('/');
                t1.pop();
                t1.push($(this).val() as string);
                var newRouteCode = t1.join('/');
                $('#routeCreateForm [name="RouteCode"]').val(newRouteCode);
                
            });           
            
            function submit(showEditForm: Boolean) {
                // Validate
                let form: any = $('#routeCreateForm');
                if (Utilities.CheckFormValidation(form)==false) return;
   
                Utilities.BlockUI($("#routeCreateModal .modal-content"));
                let formData = new FormData(<any>$('#routeCreateForm')[0]);
                $.ajax({
                    type: "POST",
                    processData: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    url: '/Route/CreateRoute',
                    data: formData,
                    success: function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                Utilities.GetModal('#routeCreateModal', ModalAction.Hide);
                                UserDefinedFields.SaveUDFFieldsAtServer($('#routeCreateForm'), '/Route/UpdateRouteUserFields');
                                events.bus.publish(events.eventClearEditLayer());
                                events.bus.publish(events.eventRefreshMapLayer(FeatureType.Route));
                                events.bus.publish(events.eventEntityUpdated(data));
                                events.bus.publish(events.eventNewMapGeometryRestart(null));

                                if (showEditForm == true) { self.openEditPanel({ code: result.data.routeCode, featureType: FeatureType.Route }) }

                                Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_CreateComplete" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });
                            }
                            else {
                                if (result.data && result.data.message) toastr.error(result.data.message);
                                else toastr.error('Failed to edit feature!');
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                        finally {
                            Utilities.UnBlockUI($("#routeCreateModal .modal-content"));
                        }
                    }
                }).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            }

            $('#routeCreateCancelBtn').on('click', function (evt) {
                Utilities.GetModal('#routeCreateModal', ModalAction.Hide);
                events.bus.publish(events.eventNewMapGeometryRestart(null));
            });
        });
    }

    // ----------------------------------------------------------- //
    // New Route WIZARD
    public newRouteWizard_Start = (data: ICAMSKey, closeWizardAfterSubmit: Boolean): void => {
        const self = this;

        // Make sure the various layers are turned on
        events.bus.publish(events.eventMapLayerVisibilitySwitch([MapLayerGroupType.Route, true]));

        // Capture the end process
        self.eventNewMapGeometryCompleted = events.bus.subscribe(events.eventNewMapGeometryCompleted, e => {
            //self.eventNewMapGeometryCompleted();
            if (e.payload[0] == true) {
                self.openCreatePanel(e.payload[1]);
            }
        });

        // Start the process
        let interactionData: IMapInteractionConfig = { zoomToSelectedFeatures: false, addToExistingSelection: false, selectableLayers: [FeatureType.Route ] };
        let config: INewGeometryConfig = { data: data, featureType: FeatureType.Route, interactionData: interactionData, skipStep2withGeom: GeometryType.LINE_STRING, tracingLayer: OptionalTracingLayer.routeLineLayer };
        events.bus.publish(events.eventNewMapGeometryStart([config, null]));
    }

    // ----------------------------------------------------------- //
    // GET FEATURE
    public getFeatureAndZoomToLocation = (data: ICAMSKey): void => {
        $.post('/Route/GetRoute', { code: data.code },
            function (result: IAPIResult) {
                try {
                    if (result.success == true) {
                        if (result.data.WKT != null) {
                            events.bus.publish(events.eventZoomToWKTandHighlight([[result.data.WKT], true, true, FeatureType.Route]));
                        }
                        else {
                            toastr.error('Failed to get link geometry!');
                        }
                    }
                    else {
                        toastr.error('Failed to get link!');
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    // ----------------------------------------------------------- //
    // DELETE
    public deleteEntity = (data: ICAMSKey): void => {
        this.EntityRouteView.deleteEntity(data);
    }

    // ----------------------------------------------------------- //
    // CREATE new linked records
    public openConditionCreatePanel = (data: ICAMSKey, callback: routeConditionCreateCallback): void => {
        this.routeCondition.openConditionCreatePanel(data, callback);
    }    
}




